export default {"src":"/_next/static/media/scroll-icon.5953a910.svg","height":138,"width":139,"blurWidth":0,"blurHeight":0};